import ClipLoader from 'react-spinners/ClipLoader';
import styles from './Spinner.module.scss';

export type SpinnerProps = {
  isLoading: boolean;
  align?: 'center' | 'left';
  size?: number;
};
export const Spinner = ({ isLoading, align = 'left', size = 48 }: SpinnerProps) => (
  <ClipLoader
    size={size}
    color="#d5db4f"
    className={styles[align]}
    loading={isLoading}
    aria-label="Loading Spinner"
    data-testid="loader"
  />
);
